export class Navbar {
    constructor() {
        this.setProperties();
        this.addEvents();
    }

    setProperties() {
        this.$body = $( 'body' );
        this.$navbar = $( '.navbar' );
        this.$searchForm = this.$navbar.find( '.search-form' ),
            this.$searchButton = this.$navbar.find( '.search-button' ),
            this.$searchWrapper = this.$navbar.find( '.search-wrapper' ),
            this.$searchInput = this.$searchWrapper.find( '.search' ),
            this.$clearSearch = this.$searchWrapper.find( '.clear-search' );
        this.$mobileOverlay = this.$body.find( '.mobile-overlay' );
        this.$mobileMenu = this.$body.find( '.mobile-menu' );
        this.$navigation = this.$navbar.find( '.navigation' );
        this.$mobileSearch = this.$mobileMenu.find( '.mobile-search' );
        this.$mobileSearchClear = this.$mobileMenu.find( '.lexa-times' );
    }

    addEvents() {
        this.handleScroll();
        this.handleSearch();
        this.handleTypography();
        this.handleContrast();
        this.handleMobileMenu();
        this.handleNavigation();
        this.getCartInfo();
    }

    handleScroll() {
        if ( this.$body.is( '#index' ) ) {
            $( window ).on( 'scroll', () => {
                if ( 0 === window.scrollY ) {
                    if ( this.$body.is( '.home' ) ) {
                        this.$body.addClass( 'extended-navbar' );
                    }
                    this.$navbar.removeClass( 'sticky' );
                } else {
                    this.$body.removeClass( 'extended-navbar' );
                    this.$navbar.addClass( 'sticky' );
                }
            } );

            if ( this.$body.is( '.home' ) ) {
                if ( 0 === window.scrollY ) {
                    this.$body.addClass( 'extended-navbar' );
                }
            }
        } else {
            this.$navbar.addClass( 'sticky' );
        }
    }

    handleSearch() {
        this.$searchButton.on( 'click', ( event ) => {
            event.preventDefault();

            this.$searchWrapper.toggleClass( 'active' );

            if ( this.$searchWrapper.is( '.active' ) ) {
                this.$searchInput.focus();
            } else if ( '' !== this.$searchInput.val() ) {
                this.$searchForm.submit();
            }
        } );

        $( window ).on( 'scroll', () => {
            this.$searchWrapper.removeClass( 'active' );
        } );

        this.$searchInput.on( 'input', () => {
            '' === this.$searchInput.val() ? this.$clearSearch.removeClass( 'active' ) : this.$clearSearch.addClass( 'active' );
        } );

        this.$clearSearch.on( 'click', () => {
            this.$clearSearch.removeClass( 'active' );
            this.$searchInput.val( '' ).focus();
        } );

        this.$body.on( 'click', ( event ) => {
            let $target = $( event.target );

            if ( !$target.is( '.search-wrapper' ) && !$target.is( '.kbf-icon-search' ) && !$target.parent().is( '.search-wrapper' ) ) {
                this.$searchWrapper.removeClass( 'active' );
            }
        } );
    }

    handleTypography() {
        let $typographyButtons = this.$body.find( '.typography-button' );

        $typographyButtons.on( 'click', function( event ) {
            event.preventDefault();

            $typographyButtons.toggleClass( 'active' );
            $( 'html' ).toggleClass( 'large-fonts' );

            if ( $.cookie( 'kbf_large_fonts' ) === 'on' )
                $.cookie( 'kbf_large_fonts', 'off' );
            else
                $.cookie( 'kbf_large_fonts', 'on' );
        } );
    }

    handleContrast() {
        const self = this;

        let $contrastButtons = this.$body.find( '.contrast-button' );

        $contrastButtons.on( 'click', function( event ) {
            event.preventDefault();

            $contrastButtons.toggleClass( 'active' );
            self.$body.toggleClass( 'hc1' );

            if ( $.cookie( 'kbf_high_contrast' ) === 'on' )
                $.cookie( 'kbf_high_contrast', 'off' );
            else
                $.cookie( 'kbf_high_contrast', 'on' );
        } );
    }

    handleMobileMenu() {
        let closeMenu = () => {
            this.$mobileOverlay.removeClass( 'active' );
            this.$mobileMenu.removeClass( 'active' );
        };

        this.$navbar.find( '.burger' ).on( 'click', ( event ) => {
            event.preventDefault();

            this.$mobileOverlay.addClass( 'active' );
            this.$mobileMenu.addClass( 'active' );
        } );

        this.$mobileOverlay.on( 'click', closeMenu );
        this.$mobileMenu.find( '.mobile-close' ).on( 'click', closeMenu );

        this.$mobileSearch.on( 'input', () => {
            if ( '' === this.$mobileSearch.val() ) {
                this.$mobileSearchClear.removeClass( 'active' );
            } else {
                this.$mobileSearchClear.addClass( 'active' );
            }
        } );

        this.$mobileSearchClear.on( 'click', () => {
            this.$mobileSearch.val( '' ).trigger( 'input' );
        } );
    }

    handleNavigation() {
        let checkOverflow = () => {
            this.$navbar.removeClass( 'menu-overflow' );

            if ( 35 < this.$navigation.outerHeight() ) {
                this.$navbar.addClass( 'menu-overflow' );
            }
        };

        $( window ).on( 'resize', checkOverflow );
        checkOverflow();
    }

    getCartInfo() {
        if ( !window.visualticketUID || !window.visualticketUrl ) {
            return;
        }

        const url = this.getHost() + '/sbCartService/cart.json' + this.getUIDParameter();

        $.ajax( {
            url:         url,
            context:     this,
            jsonp:       'callback',
            dataType:    'jsonp',
            data:        {},
            method:      'POST',
            xhrFields:   {
                withCredentials: true
            },
            crossDomain: true,
            complete:    function( jqXHR, textStatus ) {
                const quantity = Number( jqXHR.responseJSON.cart.Quantity );
                if ( quantity > 0 ) {
                    $( '.navbar .cart-button .badge' ).html( quantity )
                    $( '.navbar .cart-button .badge' ).css( 'display', 'flex' );
                }
            }

        } );
    }

    getHost() {
        let host = window.visualticketUrl;
        const appear = host.match( /http/gi );

        if ( appear.length === 2 ) {
            host = host.replace( 'https://', '' );
        }
        return host;
    }

    getUIDParameter() {
        const uid = localStorage.getItem( 'cartUID' ) ? localStorage.getItem( 'cartUID' ) : window.visualticketUID;
        const lang = $( 'html' ).attr( 'lang' );
        return (uid !== '') ? '?uid=' + uid + '&culture=' + lang + '' : '&culture=' + lang + '' + '&summary=1';
    }
}
